import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const editor: ThemeUICSSObject = {
  minHeight: '300px',
};

export default editor;
